import {
  GET_MERN_COUNTRIES,
  GET_MERN_COUNTRY,
  MERN_COUNTRY_ERROR,
} from "../types";

const CountryReducer = (state, action) => {
  switch (action.type) {
    case GET_MERN_COUNTRIES:
      return { ...state, mern_countries: action.payload };

    case GET_MERN_COUNTRY:
      return { ...state, mern_country: action.payload };

    case MERN_COUNTRY_ERROR:
      return { ...state, mern_country_error: action.payload };

    default:
      return state;
  }
};

export default CountryReducer;